export const securePackageCopy = {
  banner:
    'This is a secure internal CBM document. Do not forward this link outside the company.',
  expiryHint:
    'Links expire automatically and can only be used a limited number of times.',
  stepUpExplain:
    'Some items require a one-time verification code sent to your work inbox.',
  fallbackOnly:
    'Resending the email is for cases where the original notification did not arrive. Routine delivery is by secure link.',
};

export const securePackageFileLabels = {
  ID_BADGE: 'ID Badge',
  GOV_ID_FRONT: 'Government ID (Front)',
  GOV_ID_REAR: 'Government ID (Rear)',
  SSN_CARD: 'SSN Card',
};
